module.exports = __webpack_public_path__ + "static/img/course-2.59f354db.jpg";